import { logger } from '../helpers';

const errorManager = {
  queue: (error) => {
    logger.warn('PWA Adapter: Error manager error not queued', error);
  },
};

export default errorManager;



// WEBPACK FOOTER //
// ./Library/1.0/common/tracking/pwa-adapter/pwa-core/classes/ErrorManager.js